module.exports = __webpack_public_path__ + "static/media/nzworks_ad.76465796.jpg";